<template>
	<div
		:style="style"
		@click="click" 
		class="my-textarea" 
		@mouseleave="mouseleave"
		@mouseenter="mouseenter">
		<textarea 
			:cols="cols" 
			:rows="rows"
			@blur="blur"
			@focus="focus" 
			@input="input"
			v-model="myValue" 
			:style="inputStyle"
			:disabled="disabled"
			:placeholder="placeholder"
			class="my-textarea-inner">
		</textarea>
		<my-icon 
			size="20px" 
			icon="close"
			:color="color"
			@mousedown="clear" 
			:style="clearStyle"
			class="my-textarea-clear"/>
	</div>
</template>

<script>
	import myIcon from './my-icon.vue'
	export default {
		name: 'my-textarea',
		props: {
			value: null,
			cols: {
				type: [Number, String],
				default: 24
			},
			rows: {
				type: [Number, String],
				default: 8
			},
			disabled: {
				type: Boolean,
				default: false
			},
			color: {
				type: String,
				default: '#FFFFFF'
			},
			borderColor: {
				type: String,
				default: '#FFFFFF'
			},
			placeholder: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				myValue: this.value,
				showColor: false,
				showClear: false
			}
		},
		watch: {
			value: {
				handler(newValue) {
					this.myValue = newValue;
				}
			}
		},
		methods: {
			blur() {
				this.showColor = false;
				this.showClear = false;
				this.$emit('blur', this.myValue);
				// console.log('输入框失去焦点事件', event)
				if (navigator.userAgent.toLocaleLowerCase().includes('iphone')) {
					// ui.showToast('输入框失去焦点事件');
					window.scroll(0, 0);
				}
				// this.$message(navigator.userAgent.toLocaleLowerCase());
			},
			focus() {
				this.mouseenter();
				this.showColor = true;
				this.$emit('focus', this.myValue);
			},
			clear() {
				this.myValue = '';
				this.showClear = false;
				this.$emit('clear', '');
				this.$emit('input', '');
			},
			input() {
				this.mouseenter();
				this.$emit('input', this.myValue);
				// (this.myValue === '') && this.clear();	// 手动清空不触发
			},
			click(event) {
				this.$emit('click', event);
			},
			mouseleave() {
				if ((this.disabled === false) && (this.showColor === false)) {
					this.showClear = false;
				}
			},
			mouseenter() {
				if ((this.disabled === false) && this.myValue) {
					this.showClear = true;
				}
			}
		},
		computed: {
			style() {
				let style = this.disabled ? 'cursor: not-allowed;' : '';
				if (this.showColor && this.borderColor) {
					style += `border-color: ${this.borderColor}!important;`;
				}
				return style;
			},
			inputStyle() {
				let style = this.disabled ? 'cursor: not-allowed;' : '';
				style += `color: ${this.color}!important;`;
				return style;
			},
			clearStyle() {
				return `visibility: ${this.showClear ? 'visible' : 'hidden'}`;
			}
		},
		components: {
			'my-icon': myIcon
		}
	}
</script>

<style scoped lang="less">
	.my-textarea{
		margin: 0;
		padding: 0;
		position: relative;
		font-size: 1.6rem;
		border-radius: 2px;
		display: inline-flex;
		box-sizing: border-box;
		border: 1px solid #DCDFE6;
		background-color: transparent;
		.my-textarea-inner{
			width: 100%;
			height: 100%;
			margin: 0;
			padding: 0;
			border: none;
			padding: 7px;
			outline: none;
			font-size: inherit;
			border-radius: inherit;
			background-color: inherit;
		}
		.my-textarea-clear{
			position: absolute!important;
			z-index: 1;
			bottom: 3px;
			right: 3px;
		}
	}
</style>
